import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["value"]

import { watch, reactive, onMounted } from 'vue';
import * as service from '@/services/empresasService';

interface Props {
  modelValue?: number | null,
  placeholder?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownEmpresas',
  props: {
    modelValue: {},
    placeholder: {}
  },
  emits: ['update:modelValue', 'selected'],
  setup(__props: any, { emit: __emit }) {

var props = __props;
const emit = __emit


var controle = reactive({
  items: [] as service.Empresa[],
  id: null as number | null,
  text: "",
  status: ""
})

onMounted(() => {
  buscarItens()
})



function selecionar() {

  var empresa =   controle.items.find(c => c.empresaId === controle.id)
  if (empresa) {
    emit('update:modelValue', empresa.empresaId)
    emit('selected', empresa)
  }
  else {
    emit('update:modelValue', null)
    emit('selected', null)
  }
}


// Watch para sincronizar com modelValue externo
watch<number | null | undefined>(() => props.modelValue, (newValue) => {
  controle.id = newValue ?? null;
})


function buscarItens() {
  controle.status = "Buscando...";

  service.obter({ativo:true, tamanhoPagina: 6000}).then(response => {
    controle.items = response;
    controle.status = "";
  }).catch(error => {
    console.error("Erro ao buscar itens:", error);
    controle.status = `Erro ${error.message}`;
  })
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("select", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).id) = $event)),
    class: "form-select form-select-sm",
    onChange: _cache[1] || (_cache[1] = ($event: any) => (selecionar()))
  }, [
    _cache[2] || (_cache[2] = _createElementVNode("option", { value: null }, "- Selecione -", -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).items, (item) => {
      return (_openBlock(), _createElementBlock("option", {
        key: item.empresaId,
        value: item.empresaId
      }, _toDisplayString(item.nome), 9, _hoisted_1))
    }), 128))
  ], 544)), [
    [_vModelSelect, _unref(controle).id]
  ])
}
}

})